function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var SettingsAppspace = require('./lib/appspace/main');
var AppSettings = require('./lib/settings-settings');
var Settings = /*#__PURE__*/function (_ModTemplate) {
  function Settings(app) {
    var _this;
    _classCallCheck(this, Settings);
    _this = _callSuper(this, Settings, [app]);
    _this.app = app;
    _this.name = 'Settings';
    _this.appname = 'Settings';
    _this.slug = 'settings';
    _this.description = 'Convenient Email plugin for managing Saito account settings';
    _this["class"] = 'utility';
    _this.utilities = 'Core Utilities';
    _this.link = '/email?module=settings';
    _this.icon = 'fas fa-cog';
    _this.description = 'User settings module.';
    _this.categories = 'Admin Users';
    _this.styles = ['/settings/style.css', '/saito/lib/jsonTree/jsonTree.css'];
    _this.main = null;
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(Settings, _ModTemplate);
  return _createClass(Settings, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this2 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(Settings, "initialize", this, 3)([app]);
            case 1:
              //
              // If you have the settings page open and you trigger a name registration event
              // it will deactivate the button so you cannot reregister
              //
              this.app.connection.on('registry-update-identifier', function (publickey) {
                if (publickey === _this2.publicKey) {
                  var username = app.keychain.returnIdentifierByPublicKey(_this2.publicKey);
                  if (!username) {
                    return;
                  }
                  var btn = document.getElementById('register-identifier-btn');
                  var existing = document.getElementById('settings-username');
                  if (btn) {
                    var el = document.createElement('div');
                    el.className = 'username';
                    el.id = 'settings-username';
                    el.textContent = username;
                    btn.replaceWith(el);
                  } else if (existing) {
                    existing.textContent = username;
                  }
                }
              });
              this.app.connection.on('settings-overlay-render-request', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      if (!_this2.main) {
                        _this2.main = new SettingsAppspace(_this2.app, _this2);
                        _this2.attachStyleSheets();
                      }
                      // the slight delay gives us time to download and process the style sheets,
                      // which is better than a flicker of unstyled html
                      setTimeout(function () {
                        _this2.main.render();
                      }, 50);
                    case 1:
                      return _context.a(2);
                  }
                }, _callee);
              })));
              if (!app.options.settings) {
                app.options.settings = {
                  debug: false
                };
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "canRenderInto",
    value: function canRenderInto(qs) {
      return false;
    }

    /*
    	Note: Account Settings is hardcoded into saito-header
    	*/
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (type === 'saito-header') {
        if (this.app.modules.returnActiveModule()) {
          this.attachStyleSheets();
          return [
          /*{
          text: 'Sync Chain',
          icon: 'fa-solid fa-link',
          rank: 130,
          type: 'utilities',
          callback: async function (app, id) {
          siteMessage('Reimporting your account...');
          await app.wallet.onUpgrade('upgrade');
          reloadWindow(150);
          }
          }*/
          {
            text: 'Nuke',
            icon: 'fa-solid fa-radiation',
            rank: 130,
            type: 'utilities',
            callback: function () {
              var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, id) {
                var c;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return app.wallet.onUpgrade('nuke');
                    case 1:
                      c = _context3.v;
                      if (c) {
                        reloadWindow(150);
                      }
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              }));
              function callback(_x2, _x3) {
                return _callback.apply(this, arguments);
              }
              return callback;
            }()
          }];
        }
      }
      return null;
    }
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }

    /**
     * Lite clients request the connected node's build number to compare with the browser bundle.
     */
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app) {
        var _txmsg;
        var tx,
          peer,
          mycallback,
          txmsg,
          _args4 = arguments,
          _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              tx = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;
              peer = _args4.length > 2 ? _args4[2] : undefined;
              mycallback = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : null;
              if (!(tx == null)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, 0);
            case 1:
              _context4.p = 1;
              txmsg = tx.returnMessage();
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t = _context4.v;
              return _context4.a(2, 0);
            case 3:
              if (!(((_txmsg = txmsg) === null || _txmsg === void 0 ? void 0 : _txmsg.request) === 'settings server build')) {
                _context4.n = 4;
                break;
              }
              if (!mycallback) {
                _context4.n = 4;
                break;
              }
              mycallback({
                build_number: String(this.app.build_number)
              });
              return _context4.a(2, 1);
            case 4:
              return _context4.a(2, _superPropGet(Settings, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee4, this, [[1, 2]]);
      }));
      function handlePeerTransaction(_x4) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "loadSettings",
    value: function loadSettings(container) {
      var as = new AppSettings(this.app, this, container);
      as.render();
    }
  }]);
}(ModTemplate);
module.exports = Settings;